import React, { createContext, useEffect, useState } from 'react';

import { getListViewState } from './utils';

export const InventoryListTemplateProviderContext = createContext({});

export const InventoryListTemplateProvider = ({ children }) => {
  const listViewStates = getListViewState();

  const [selectedStores, setSelectedStores] = useState([]);

  useEffect(() => {
    listViewStates.setCurrentPage(1);
  }, [selectedStores]);

  return (
    <InventoryListTemplateProviderContext.Provider
      value={{
        ...listViewStates,
        selectedStores,
        setSelectedStores,
      }}
    >
      {children}
    </InventoryListTemplateProviderContext.Provider>
  );
};

export default InventoryListTemplateProviderContext;
